import { render, staticRenderFns } from "./CardBlog.vue?vue&type=template&id=36ea8d5a"
import script from "./CardBlog.vue?vue&type=script&lang=js"
export * from "./CardBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports